export default "__VITE_ASSET__DLri48Lg__"